module.exports = __webpack_public_path__ + "static/media/funnel_effect_mobile.3a662b34.png";